import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import "../css/Login.css";
import logo from "../images/matecareer_logo.webp";
import { useAuth } from "../context/AuthContext";

function Login() {


  const navigate = useNavigate();
  const { fetchUserData } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/crm/login", { email, password });
      const token = response.data.data;

      localStorage.setItem("token", token); // ← use data.token
      localStorage.setItem("tokenExpiry", Date.now() + 24 * 60 * 60 * 1000);

      await fetchUserData();
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        {/* <img src={logo} alt="Logo" className="login-logo" /> */}
        <p></p>
        <h1>Mate Career</h1>
      </div>
      <div className="login-right">
        <img src={logo} alt="Logo" className="login-logo" />
        <h3 style={{ marginBottom: 24 }}>CRM Tool To Manage Leads</h3>
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

export default Login;
